import { config } from "./_config";

const authDomain = `${config.tenant}.b2clogin.com`;
export default authDomain;
